/**
 * Constantes de comércio exterior reutilizadas em Fornecedores, Cotações e Pedidos.
 */

// Principais parceiros comerciais + Brasil. code = ISO2, moeda_sugerida ajuda a pré-selecionar.
export const PAISES = [
  { code: 'BR', nome: 'Brasil', moeda: 'BRL' },
  { code: 'US', nome: 'Estados Unidos', moeda: 'USD' },
  { code: 'CN', nome: 'China', moeda: 'CNY' },
  { code: 'NO', nome: 'Noruega', moeda: 'NOK' },
  { code: 'DE', nome: 'Alemanha', moeda: 'EUR' },
  { code: 'IT', nome: 'Itália', moeda: 'EUR' },
  { code: 'FR', nome: 'França', moeda: 'EUR' },
  { code: 'ES', nome: 'Espanha', moeda: 'EUR' },
  { code: 'NL', nome: 'Países Baixos', moeda: 'EUR' },
  { code: 'GB', nome: 'Reino Unido', moeda: 'GBP' },
  { code: 'JP', nome: 'Japão', moeda: 'JPY' },
  { code: 'KR', nome: 'Coreia do Sul', moeda: 'KRW' },
  { code: 'SE', nome: 'Suécia', moeda: 'SEK' },
  { code: 'DK', nome: 'Dinamarca', moeda: 'DKK' },
  { code: 'FI', nome: 'Finlândia', moeda: 'EUR' },
  { code: 'PT', nome: 'Portugal', moeda: 'EUR' },
  { code: 'CA', nome: 'Canadá', moeda: 'CAD' },
  { code: 'MX', nome: 'México', moeda: 'MXN' },
  { code: 'AR', nome: 'Argentina', moeda: 'ARS' },
  { code: 'IN', nome: 'Índia', moeda: 'INR' },
  { code: 'OTHER', nome: 'Outro país', moeda: 'USD' },
];

export const isBrasil = (pais) => !pais || pais === 'BR' || String(pais).toLowerCase() === 'brasil';

export const getPaisNome = (code) => (PAISES.find((p) => p.code === code)?.nome) || code || '';

// Incoterms 2020
export const INCOTERMS = [
  { code: 'EXW', nome: 'EXW — Ex Works (na fábrica)' },
  { code: 'FCA', nome: 'FCA — Free Carrier' },
  { code: 'FAS', nome: 'FAS — Free Alongside Ship' },
  { code: 'FOB', nome: 'FOB — Free On Board' },
  { code: 'CFR', nome: 'CFR — Cost and Freight' },
  { code: 'CIF', nome: 'CIF — Cost, Insurance and Freight' },
  { code: 'CPT', nome: 'CPT — Carriage Paid To' },
  { code: 'CIP', nome: 'CIP — Carriage and Insurance Paid To' },
  { code: 'DAP', nome: 'DAP — Delivered At Place' },
  { code: 'DPU', nome: 'DPU — Delivered At Place Unloaded' },
  { code: 'DDP', nome: 'DDP — Delivered Duty Paid' },
];

export const TIPO_FORNECEDOR = [
  { code: 'fabricante', nome: 'Fabricante' },
  { code: 'distribuidor', nome: 'Distribuidor' },
];
